<div class="forgot-password-page">
    <div class="forgot-password-wrap">
        <img
            class="forgot-password-logo"
            alt="HOMER - Health Operations & Medical Emergency Response"
            src="assets/images/logos/logo.png"
        />

        <div class="forgot-password-card rounded bg-light border">
            <div class="border-bottom p-3 text-center forgot-password-header rounded-top">
                <h3 class="mb-0">{{ checkEmail ? 'Check your email' : 'Forgot Password' }}</h3>
            </div>

            <div class="p-4">
                @if (!checkEmail) {
                    <form
                        (ngSubmit)="onSubmit()"
                        [formGroup]="forgotPasswordForm"
                    >
                        <div class="mb-3">
                            <p-floatlabel variant="on">
                                <p-iconfield>
                                    <input
                                        pInputText
                                        class="w-100"
                                        formControlName="email"
                                        autocomplete="email"
                                    />
                                    <p-inputicon styleClass="pi pi-envelope" />
                                </p-iconfield>
                                <label>Email</label>
                            </p-floatlabel>
                        </div>

                        <p-button
                            class="w-100"
                            type="submit"
                            label="Send Email"
                            styleClass="w-100"
                            raised
                            severity="info"
                        />

                        <div class="d-flex justify-content-center mt-2">
                            <p-button
                                label="Back to Login"
                                [link]="true"
                                severity="info"
                                size="small"
                                (onClick)="router.navigate(['/login'])"
                            />
                        </div>
                    </form>
                } @else {
                    <p class="text-center mb-3">Please check your email to reset your password.</p>
                    <div class="d-flex justify-content-center">
                        <p-button
                            label="Back to Login"
                            [link]="true"
                            severity="info"
                            size="small"
                            (onClick)="router.navigate(['/login'])"
                        />
                    </div>
                }
            </div>
        </div>
    </div>
</div>

<div #footerEl id="divisionFooter" class="fdepcs-footer">Florida Division of Emergency Preparedness and Community Support</div>
